import { KnownSearchResultItemDtoType, SearchResultItemDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { getResultPath } from '../search-navigation';
import { DeliveryResultItem } from './delivery-result-item.component';
import { FallbackResultItem } from './fallback-result-item.component';
import { HubResultItem } from './hub-result-item.component';
import { OrderResultItem } from './order-result-item.component';
import { PersonResultItem } from './person-result-item.component';
import { ProjectResultItem } from './project-result-item.component';

export interface SearchResultItemProps {
  item: SearchResultItemDto;
  currentProjectID?: string;
  onNavigate: (item: SearchResultItemDto) => void;
}

/**
 * Tier-1 dispatch: selects the per-type component for a result. Each per-type component owns its own
 * `subType` switch for icon/detail. A row is rendered as an anchor (clickable + open-in-new-tab)
 * when a detail route can be resolved (see {@link getResultPath}); otherwise it renders as static text.
 */
export function SearchResultItem({ item, currentProjectID, onNavigate }: SearchResultItemProps) {
  const href = getResultPath(item, currentProjectID);
  const onClick = href ? () => onNavigate(item) : undefined;

  switch (item.type) {
    case KnownSearchResultItemDtoType.Project:
      return <ProjectResultItem item={item} href={href} onClick={onClick} />;
    case KnownSearchResultItemDtoType.UserOrAccount:
      return <PersonResultItem item={item} href={href} onClick={onClick} />;
    case KnownSearchResultItemDtoType.Hub:
      return <HubResultItem item={item} href={href} onClick={onClick} />;
    case KnownSearchResultItemDtoType.Delivery:
      return <DeliveryResultItem item={item} href={href} onClick={onClick} />;
    case KnownSearchResultItemDtoType.Order:
      return <OrderResultItem item={item} href={href} onClick={onClick} />;
    default:
      return <FallbackResultItem item={item} href={href} onClick={onClick} />;
  }
}
